/** True when `pathname` is `url` itself or any route nested under it; `/` only matches exactly. */
export const isLinkActive = (pathname: string, url: string) =>
  pathname === url || (url !== '/' && pathname.startsWith(`${url}/`));
